export const roles = {
	admin: 'Admin',
	sales: 'Sales',
	salesSap: 'SalesSAP',
	marketing: 'Marketing',
	unauthorized: 'Unauthorized'
};
